<!-- <button (click)="getPetKey()">petKey</button> -->
<ng-container *ngIf="type == 'feed' ">
    <div class="status">
        <ng-container *ngFor="let pet of pets">
            <div class="status-child" *ngIf="pet.ForceFeeding" [ngClass]=" pet.name == currentPetName ? 'green_select' :'unselect' ">
                <mat-icon style="margin-right: 10px; color: #b1b3b1;">pets</mat-icon>
                <span style="text-transform: uppercase; font-weight: 500;">{{pet.name}}</span>
            </div>
        </ng-container>
        
    </div>
    
   
    <div class="btn-header btn warps" style="margin-bottom: 20px;">
        <p>Feeding Schedule for {{currentPetName}}</p>
        <!-- <button mat-button style="background-color:#41A049;" (click)="addTime()">Add Time</button> -->
        <button mat-button style="background-color:#41A049;" (click)="openDialog()">Add Time</button>
    </div>
    <mat-progress-bar mode="indeterminate" *ngIf="buffer"></mat-progress-bar>

    <table mat-table [dataSource]="data" class="mat-elevation-z8" style="width:100%">
        <!-- feedSchedule Column -->
        <ng-container matColumnDef="feedSchedule">
            <th mat-header-cell *matHeaderCellDef> Schedule </th>
            <td mat-cell *matCellDef="let element">
                {{element.feedSchedule && element.feedSchedule.time ? element.feedSchedule.time : ''}}
            </td>
        </ng-container>
        <!-- feedAmount Column -->
        <ng-container matColumnDef="feedAmount">
            <th mat-header-cell *matHeaderCellDef> Amount </th>
            <td mat-cell *matCellDef="let element">
                {{element.feedAmount && element.feedAmount.amount ? element.feedAmount.amount : ''}}
            </td>
        </ng-container>



        <!-- feedUnit Column -->
        <ng-container matColumnDef="feedUnit">
            <th mat-header-cell *matHeaderCellDef> Unit </th>
            <td mat-cell *matCellDef="let element">
                {{element.feedUnit && element.feedUnit.unit ? element.feedUnit.unit : ''}}
            </td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef> Description </th>
            <td mat-cell *matCellDef="let element">
                {{element.description}}
            </td>
        </ng-container>

        <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef> Action </th>
            <td mat-cell *matCellDef="let element">
                <mat-icon style="color:rgb(75, 62, 177); cursor: pointer; margin-right: 5px;"
                    (click)="edit(element)">edit</mat-icon>

                <mat-icon style="color:red; cursor: pointer;" (click)="delete(element)">delete</mat-icon>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="Columns"></tr>
        <tr mat-row *matRowDef="let row; columns: Columns;"></tr>
    </table>

    <div *ngIf="data.length==0" style="height: 150px;
    border: 1px dashed green;
    text-align: center;
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;">
        <p style=" letter-spacing: 2px;">
            Let Us Know About Your Pet's Feeding
        </p>
        <p>
            <mat-icon style="display: block; font-size: 50px;">pets</mat-icon>
        </p>

    </div>
    <!-- feeding card -->
    <div style="margin-top: 20px;" class="end-card" *ngIf="data.length !=0">
        <div>
            <mat-form-field>
                <mat-label>Feeding Type</mat-label>
                <mat-select [(ngModel)]="petFeedType.id" (selectionChange)="feedChanged()">
                    <mat-option *ngFor="let type of FeedType" [value]="type.id">
                        {{type.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field>
                <mat-label>Feeding Method</mat-label>
                <mat-select [(ngModel)]="petFeedMethod.id" (selectionChange)="feedChanged()">
                    <mat-option *ngFor="let method of FeedMethod" [value]="method.id">
                        {{method.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field style="width:100%">
                <mat-label>Description</mat-label>
                <textarea matInput [(ngModel)]="feedDescription" (input)="feedChanged()"></textarea>
            </mat-form-field>
        </div>

    </div>
    <p class="errorStyle">{{feedError}}</p>
    <div style="justify-content: end;display: flex; margin: 20px;">

        <button mat-raised-button style="color: white;" (click)="submit()"
            [disabled]="data.length==0 || !feedSubmitControl"
            [ngClass]="data.length == 0 ? 'dark':'white'">Save</button>

        <button mat-raised-button style="margin-left: 10px;" [disabled]="!nextControl" (click)="next()">Next</button>
        
    </div>
</ng-container>


<ng-container *ngIf="type == 'med' ">

    <div class="status">
        <ng-container *ngFor="let pet of pets">
            <div class="status-child" *ngIf="pet.ForceMedication" [ngClass]=" pet.name == currentPetName ? 'green_select' :'unselect' ">
                <mat-icon style="margin-right: 10px; color: #b1b3b1;">pets</mat-icon>
                <span style="text-transform: uppercase; font-weight: 500;">{{pet.name}}</span>
            </div>
        </ng-container>
        
    </div>

    <div class="btn-header btn warps" style="margin-bottom: 20px;">
        <p>Medication Schedule For {{currentPetName}}</p>
        <!-- <button mat-button style="background-color:#41A049;" (click)="addTime()">Add Time</button> -->
        <button mat-button style="background-color:#41A049;" (click)="OpenMedDialog()">Add Time</button>
    </div>
    <mat-progress-bar mode="indeterminate" *ngIf="buffer"></mat-progress-bar>

    <table mat-table [dataSource]="Meddata" class="mat-elevation-z8" style="width:100%">

        <!-- feedSchedule Column -->
        <ng-container matColumnDef="MedSchedule">
            <th mat-header-cell *matHeaderCellDef style="width:100px"> Schedule </th>
            <td mat-cell *matCellDef="let element">
                {{element.medicationSchedule && element.medicationSchedule.time ? element.medicationSchedule.time : ''}}
            </td>
        </ng-container>
        <!-- feedAmount Column -->
        <ng-container matColumnDef="MedAmount">
            <th mat-header-cell *matHeaderCellDef style="width:100px"> Amount </th>
            <td mat-cell *matCellDef="let element">
                {{element.medicationAmount && element.medicationAmount.amount ? element.medicationAmount.amount : ''}}
            </td>
        </ng-container>



        <!-- feedUnit Column -->
        <ng-container matColumnDef="MedUnit">
            <th mat-header-cell *matHeaderCellDef style="width:100px"> Unit </th>
            <td mat-cell *matCellDef="let element">
                {{element.medicationUnit && element.medicationUnit.unit ? element.medicationUnit.unit : ''}}
            </td>
        </ng-container>
        <!--  -->
        <ng-container matColumnDef="MedType">
            <th mat-header-cell *matHeaderCellDef style="width:100px"> Type </th>
            <td mat-cell *matCellDef="let element">
                {{element.medicationType && element.medicationType.name ? element.medicationType.name : ''}}
            </td>
        </ng-container>
        <ng-container matColumnDef="description" style="width:100px">
            <th mat-header-cell *matHeaderCellDef> Description </th>
            <td mat-cell *matCellDef="let element">
                {{element.description}}
            </td>
        </ng-container>

        <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef> Action </th>
            <td mat-cell *matCellDef="let element">
                <mat-icon style="color:rgb(75, 62, 177); cursor: pointer; margin-right: 5px;"
                    (click)="editMed(element)">edit</mat-icon>

                <mat-icon style="color:red; cursor: pointer;" (click)="deleteMed(element)">delete</mat-icon>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="MedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: MedColumns;"></tr>
    </table>

    <div *ngIf="Meddata.length==0" style="height: 150px;border: 1px dashed green;text-align: center;padding: 15px; display: flex;
    flex-direction: column;
    align-items: center;">
        
            <p style="letter-spacing: 2px;">
                Let Us Know About Your Pet's Medication
            </p>
            <p>
                <mat-icon style="display: block; font-size: 50px;">medical_information</mat-icon>
            </p>
        
        

    </div>
    <!-- Medication card -->
    <div style="margin-top: 20px;" class="end-card" *ngIf="Meddata.length !=0">
        <div>
            <mat-form-field style="width:100%">
                <mat-label>Medication Notes</mat-label>
                <textarea matInput [(ngModel)]="MedDescription" (input)="medChange()"></textarea>
            </mat-form-field>
        </div>
    </div>
   
    <div style="justify-content: end;display: flex; margin: 20px;">
        <!-- <button mat-button (click)="getPetMed()"
            style="background-color: antiquewhite; margin-right: 10px;">Reset</button> -->
        <button mat-raised-button style="color: white;" (click)="submitMed()"
            [disabled]="Meddata.length==0 || !medSubmitControl"
            [ngClass]="Meddata.length == 0 ? 'dark':'white'">Save</button>
        <button mat-raised-button style="margin-left: 10px;" [disabled]="!nextMedControl" (click)="nextMed()">Next</button>
    </div>
</ng-container>

<ng-container *ngIf="type == 'card' ">
    <mat-progress-bar mode="indeterminate" *ngIf="buffer"></mat-progress-bar>
    <table mat-table [dataSource]="cardData" class="mat-elevation-z8" style="width:100%; margin-bottom: 10px;">
        <!-- <ng-container matColumnDef="card">
          <th mat-header-cell *matHeaderCellDef> Card </th>
          <td mat-cell *matCellDef="let element"> {{element.position}} </td>
        </ng-container> -->

        <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Details </th>
            <td mat-cell *matCellDef="let element">
                <div  class="cod_inner">

            
                <mat-radio-button [value]="element" (change)="handleChange($event)"></mat-radio-button>

                <mat-icon style="margin-right: 10px;">credit_card</mat-icon>
                   
                    <div style="display: flex;
                align-items: center;
                /* font-size: 15px; */
                font-weight: 550;">**** **** **** {{element.lastFourDigit.substring(element.lastFourDigit.length-4)}}</div>
                </div>

            </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Action </th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
                <mat-icon style="color:red; cursor: pointer;" (click)="deleteCard(element)">delete</mat-icon>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="CardColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: CardColumns;"></tr>
    </table>


    <div *ngIf="cardData.length==0" style="height: 150px;border: 1px dashed green;text-align: center;padding: 15px;display: flex;
    flex-direction: column;
    align-items: center;">

        <p style="letter-spacing: 2px;">
            Add Your Card
        </p>
        <p>
            <mat-icon style="display: block; font-size: 70px;
            transform: translate(-25px, -2px);">credit_card</mat-icon>
        </p>
    </div>
</ng-container>